import { MockAuthAdapter } from "~/core/adapters/auth/mock-auth-adapter";
import { FirebaseAuthAdapter } from "~/core/adapters/auth/firebase-auth-adapter";
import { SupabaseAuthAdapter } from "~/core/adapters/auth/supabase-auth-adapter";
import { IAuthAdapter } from "~/core/domain/services/i-auth-adapter";
import { IS_MOCK_AUTH_CLIENT } from "~/infra/auth/mock-auth";

/**
 * 認証アダプターの依存性注入（DIコンテナ）
 *
 * 環境変数AUTH_PROVIDERで認証プロバイダーを切り替え可能
 * - "supabase" (デフォルト): Supabase認証を使用
 * - "firebase": Firebase認証を使用
 *
 * 注意: clientLoader/clientActionを使用するため、クライアントサイドのみをサポート
 */
let _clientAuthAdapter: IAuthAdapter | null = null;

export function getAuthAdapter(): IAuthAdapter {
  if (_clientAuthAdapter === null) {
    if (IS_MOCK_AUTH_CLIENT) {
      _clientAuthAdapter = new MockAuthAdapter();
      return _clientAuthAdapter;
    }
    const provider = import.meta.env.VITE_AUTH_PROVIDER || "supabase";
    if (provider === "firebase") {
      _clientAuthAdapter = new FirebaseAuthAdapter();
    } else {
      // デフォルトはSupabase
      _clientAuthAdapter = new SupabaseAuthAdapter();
    }
  }
  return _clientAuthAdapter;
}
